/**
 * Mapping dei messaggi di errore Cognito → italiano.
 * Replica il mapping inline degli screen mobile (SignInScreen, MfaScreen,
 * ResetPasswordScreen) ma centralizzato.
 */

const ERROR_MAP: Record<string, string> = {
  UserNotFoundException: 'Nome utente non trovato.',
  NotAuthorizedException: 'Nome utente o password non corretti.',
  UserAlreadyAuthenticatedException: 'Sessione già attiva. Ricarica la pagina.',
  CodeMismatchException: 'Codice errato. Riprova.',
  ExpiredCodeException: 'Codice scaduto. Richiedi un nuovo codice.',
  LimitExceededException: 'Hai superato il limite di tentativi. Riprova più tardi.',
  TooManyRequestsException: 'Troppe richieste. Riprova fra qualche minuto.',
  InvalidParameterException: 'Dati non validi. Controlla i campi e riprova.',
  InvalidPasswordException:
    'La password non rispetta i requisiti minimi (8 caratteri, maiuscola, minuscola, numero).',
  PasswordResetRequiredException: 'È necessario reimpostare la password.',
  UserNotConfirmedException: 'Utente non confermato. Contatta il supporto.',
}

/**
 * Estrae un messaggio italiano per l'utente da un errore Cognito.
 * Cade su `error.message` o un generico se non riconosciuto.
 */
export function translateCognitoError(err: unknown): string {
  if (!err) return 'Si è verificato un errore.'

  if (err instanceof Error) {
    if (err.name in ERROR_MAP) return ERROR_MAP[err.name]

    const lower = err.message.toLowerCase()
    if (lower.includes('incorrect username or password')) {
      return ERROR_MAP.NotAuthorizedException
    }
    return err.message
  }

  return 'Si è verificato un errore.'
}
